import {EventEmitter} from 'events'
import {readsSource} from './readLocale.coffee'

class I18nManager extends EventEmitter
  # @localeConfig is the manifest's {sourceLocale, supportedLocales}; absent on
  # a page that loaded no manifest, where readsSource() falls back cautiously.
  constructor: (@clientAPI, initialLocale = 'en', @localeConfig = null) ->
    super()
    # Initialize with provided locale or default to 'en'
    # The locale can be updated later via setLocale()
    @currentLocale = initialLocale

  setLocale: (locale) ->
    @currentLocale = locale
    @emit('localeChanged', locale)

    # Persist to database by updating the logged-in user
    try
      if @clientAPI.model == 'Login'
        await @clientAPI.Login.updateAttributes({preferredLanguage: locale})
      else if @clientAPI.model == 'Student'
        await @clientAPI.Student.updateAttributes({preferred_language: locale})
    catch error
      console.error "Failed to persist locale change:", error

  getLocale: () ->
    @currentLocale

  # Does a reader in `locale` get the authored text? Ask THIS, never compare a
  # locale to 'en': a browser reports 'en-US' (card 6aa6c73847c945dd8596e7d9).
  readsSource: (locale = @currentLocale) ->
    readsSource(locale, @localeConfig)

# Create singleton
export i18nManager = null

export initI18n = (clientAPI, initialLocale = 'en') ->
  window.i18nManager = new I18nManager(clientAPI, initialLocale, clientAPI?.schema?.i18n)
  return window.i18nManager
